module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_orange_09-680bb57a3c99829e836062de585d70b2.svg";